export var ETemplateDocumentStatus;
(function (ETemplateDocumentStatus) {
    ETemplateDocumentStatus["New"] = "NEW";
    ETemplateDocumentStatus["Generating"] = "GENERATING";
    ETemplateDocumentStatus["Generated"] = "GENERATED";
    ETemplateDocumentStatus["Failed"] = "FAILED";
})(ETemplateDocumentStatus || (ETemplateDocumentStatus = {}));
